<template>
  <div class="messages">
    <message
      v-for="message in messages"
      :message="message"
      v-if="currentChatGroup"
    ></message>
    <div class="get-more-messages-btn" v-if="showGetMoreMessages" @click="getMoreMessages()">取得更多訊息</div>
    <i class="loading fa fa-cog fa-spin fa-3x fa-fw"  v-if="showLoading()"></i>
  </div>
</template>


<script>
import Message from './message.vue'

export default {
  props: ['currentChatGroup', 'messages'],
  data() {
    return {
      newMessage: ""
    };
  },
  components: {
    Message
  },
  created() {},


  computed: {
    showGetMoreMessages() {
      return this.currentChatGroup && !this.currentChatGroup.reachTheEnd && (this.messages.length !== 0);
    }
  },

  methods: {
    getMoreMessages() {
      return eventHub.$emit('get-more-messages',  this.currentChatGroup, this.messages[this.messages.length - 1].id);
    },
    showLoading() {
      return false;
    }
  }

}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/messages.vue